import { render, staticRenderFns } from "./ReviewAutocomplete.vue?vue&type=template&id=8373e5cc&"
import script from "./ReviewAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ReviewAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports